<template>
  <div class="container">
    <div class="columns">
      <section class="column is-6">
        <header><LsSupportHeader label="Long Grass Dispute" /></header>
        <main>
          <LsIcon class="fail-icon" type="exclamation" color="danger" size="lg" />
          <h2>Something went wrong!</h2>
          <p>We are unable to process your dispute request. Please try again in a few minutes.</p>
          <LsButton
            text="Try again"
            track-id="longgrass_dispute-try_again_dispute"
            test-id="try_again_dispute_button"
            bg-color="primary"
            text-color="white"
            @click="retry"
          />
        </main>
      </section>
    </div>
  </div>
</template>

<script>
import { LsButton, LsIcon } from '@/components/common';
import { LsSupportHeader } from '@/views/Authorized/SupportView/components';

export default {
  name: 'LongGrassDisputeFail',
  components: { LsButton, LsIcon, LsSupportHeader },
  methods: {
    retry() {
      const { form } = this.$route.params;
      this.$router.push({ name: 'LongGrassDispute', params: { form, isBack: true } });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  header {
    margin-bottom: 3rem;
  }

  .fail-icon {
    margin-bottom: 2rem;
  }

  h2 {
    color: $theme-color-danger;
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.4rem;
    margin-bottom: 2rem;
  }
}
</style>
